import {getCookie, setCookie, swalError, swalSuccessNoButton, swalSuccessWithButton} from "./core";

class Auth {
    // Login users from header
    headerLogin() {
        let $form = $('#header-login-form').filter(function () {
            return Auth.validLoginAction($(this));
        }).first();
        let $button = $('#header-login-user');
        if (!$button.length || !$form.length) {
            return;
        }

        $form.off('submit.authAjaxLogin').on('submit.authAjaxLogin', function (e) {
            e.preventDefault();
            Auth.login($button, $form);
        });

        $button.off('click.authAjaxLogin').on('click.authAjaxLogin', function () {
            Auth.login($button, $form);
        });

        $form.off('keypress.authAjaxLogin').on('keypress.authAjaxLogin', function (event) {
            if (event.keyCode === 13) {
                event.preventDefault();
                $button.trigger('click');
            }
        });
    }

    // Login users from form
    formLogin() {
        let $form = $('form#login-form').filter(function () {
            return Auth.validLoginAction($(this));
        }).first();
        let $button = $form.find('#login-user');
        if (!$button.length || !$form.length) {
            return;
        }

        $form.off('submit.authAjaxLogin').on('submit.authAjaxLogin', function (e) {
            e.preventDefault();
            Auth.login($button, $form);
        });

        $button.off('click.authAjaxLogin').on('click.authAjaxLogin', function () {
            Auth.login($button, $form);
        });

        $form.off('keypress.authAjaxLogin').on('keypress.authAjaxLogin', function (event) {
            if (event.keyCode === 13) {
                event.preventDefault();
                $button.trigger('click');
            }
        });

        $(function () {
            $('[data-toggle="tooltip"]').tooltip();

            $(document).on('input', '.form-templates-v5 .animation-label', function () {
                if($(this).val() && $(this).val().length > 0) {
                    $(this).addClass('active')
                } else {
                    $(this).removeClass('active')
                }
            })

            $.each($('.form-templates-v5 .animation-label'), function (inputIndex, inputValue) {
                if($(this).val() && ($(this).val()).length > 0) {
                    $(this).addClass('active')
                } else {
                    $(this).removeClass('active')
                }
            })
        })
    }

    // Confirm password
    passwordConfirm() {
        let $button = $('#password-confirm');
        let $form = $('#password-confirm-form');

        $button.click(function() {
            $button.button('loading');
            $.ajax({
                url: $form.attr('action'),
                method: 'post',
                dataType: 'json',
                data: $form.serialize()

            }).done(json => {
                swalSuccessWithButton(json);
                setTimeout(() => window.location.href = json.data.route, 1000);

            }).fail(function (json) {
                swalError(json);

            }).always(function () {
                $button.button('reset');
            });
        });

        $form.keypress(function(event) {
            if (event.keyCode === 13) {
                event.preventDefault();
                $button.click();
            }
        });
    }

    // Password reset
    passwordReset() {
        let $button = $('#password-reset');
        let $form = $('#password-reset-form');

        $button.click(function() {
            $button.button('loading');
            $.ajax({
                url: $form.attr('action'),
                method: 'post',
                dataType: 'json',
                data: $form.serialize()

            }).done(json => {
                $form.trigger('reset');
                swalSuccessWithButton(json);

            }).fail(function (json) {
                swalError(json);

            }).always(function () {
                $button.button('reset');
            });
        });

        $form.keypress(function(event) {
            if (event.keyCode === 13) {
                event.preventDefault();
                $button.click();
            }
        });
    }

    /**
     * Evita POST a "/" (home solo admite GET): action vacío, "#", o URL cuya ruta sea "/".
     * El login real debe ir a la ruta de authenticate (p. ej. …/auth/authenticate).
     */
    static validLoginAction($form) {
        const raw = ($form.attr('action') || '').trim();
        if (!raw.length || raw === '#') {
            return false;
        }
        try {
            const u = new URL(raw, window.location.href);
            let path = (u.pathname || '').replace(/\/+$/, '');
            if (path === '' || path === '/') {
                return false;
            }
            return path.toLowerCase().includes('authenticate');
        } catch (e) {
            return false;
        }
    }

    // Login users
    static login($button, $form) {
        if (!$button || !$button.length || !$form || !$form.length || !Auth.validLoginAction($form)) {
            return;
        }
        $button.button('loading');
        $.ajax({
            url: $form.attr('action'),
            type: 'post',
            data: $form.serialize()

        }).done(function(json) {
            swalSuccessNoButton(json);
            setTimeout(() => {
                window.location.href = json.data.route;
                setCookie('language-js', json.data.language, 365)
            }, 1000);

        }).fail(function(json) {
            swalError(json);

        }).always(function() {
            $button.button('reset')
        });
    }
}
window.Auth = Auth;
